import 'reflect-metadata';

import { BeforeInsert, Column, Entity, JoinColumn, OneToMany, ManyToOne, PrimaryGeneratedColumn } from 'typeorm';
import { Contact } from './contact.entity';
import { Lieu } from './lieu.entity';
import { Activite, BaseEntite, EntiteSommaireStatique, EntiteStatique, Produit } from './index';

@EntiteSommaireStatique<MethodePaiement>()
@EntiteStatique()
@Entity('methode_paiement')
export class MethodePaiement implements BaseEntite {
    static key = 'methodes-paiement';
    static proprietesSommaire = ['name'] as (keyof MethodePaiement)[];

    @PrimaryGeneratedColumn()
    id: number;
    @Column()
    name: string;
}

@EntiteStatique()
@Entity('status_entreprise')
export class StatutEntreprise implements BaseEntite {
    static key = 'statuts-entreprise';
    @PrimaryGeneratedColumn()
    id: number;
    @Column()
    name: string;
}

@EntiteStatique()
@Entity('fournisseur')
export class Fournisseur implements BaseEntite {
    static key = 'fournisseurs';

    @PrimaryGeneratedColumn()
    id: number;
    @Column({ type: 'text' })
    name = '';
    @Column({ type: 'timestamp', nullable: true })
    created_at: string;
    @Column({ nullable: true })
    fk_id_contact_gestionnaire: number;
    @ManyToOne(() => Contact)
    @JoinColumn({ name: 'fk_id_contact_gestionnaire', referencedColumnName: 'id' })
    contact_gestionnaire: Contact;
    @Column({ nullable: true })
    fk_id_contact_par_defaut: number;
    @ManyToOne(() => Contact)
    @JoinColumn({ name: 'fk_id_contact_par_defaut', referencedColumnName: 'id' })
    contact_par_defaut: Contact;
    @Column({ nullable: true })
    fk_id_lieu: number;
    @ManyToOne(() => Lieu)
    @JoinColumn({ name: 'fk_id_lieu', referencedColumnName: 'id' })
    lieu: Lieu;
    @Column({ type: 'text', nullable: true })
    notes = '';
    @Column({ type: 'numeric', nullable: true })
    pct_commission_defaut: number | '' = '';
    @Column({ type: 'boolean', nullable: true, default: false })
    b_entente = false;
    @Column({ type: 'date', nullable: true })
    trigger_suivi = '';
    @Column({ type: 'date', nullable: true })
    debut_relation_date = '';
    @Column({ nullable: true })
    fk_methode_paiement: number;
    @ManyToOne(() => MethodePaiement, { eager: false })
    @JoinColumn({ name: 'fk_methode_paiement', referencedColumnName: 'id' })
    methode_paiement: MethodePaiement;
    @Column({ type: 'integer', nullable: true })
    delais_reception_facture: number | '' = '';
    @Column({ type: 'text', nullable: true })
    delais_reception_facture_texte = '';
    @Column({ nullable: true })
    fk_status_entreprise: number;
    @ManyToOne(() => StatutEntreprise)
    @JoinColumn({ name: 'fk_status_entreprise', referencedColumnName: 'id' })
    status_entreprise: StatutEntreprise;
    @Column({ type: 'text', nullable: true })
    nom_acces_d = '';
    @Column({ type: 'text', nullable: true })
    neq = '';
    @Column({ type: 'text', nullable: true })
    tps = '';
    @Column({ type: 'text', nullable: true })
    tvq = '';
    @Column({ type: 'boolean', name: 'b_actif', nullable: true, default: true })
    actif = true;

    @OneToMany(() => Activite, (activite: Activite) => activite.fournisseur)
    activites: Activite[];

    @OneToMany(() => Produit, (produit: Produit) => produit.fournisseur)
    produits: Produit[];

    @BeforeInsert()
    updateCreatedAt(): void {
        this.created_at = new Date().toUTCString();
    }
}

@Entity('fournisseur', { synchronize: false })
export class FournisseurVitrine implements BaseEntite {
    static key = 'fournisseurs';

    @PrimaryGeneratedColumn()
    id: number;
    @Column({ type: 'text' })
    name = '';
    @Column({ type: 'boolean', name: 'b_actif', nullable: true, default: true })
    actif = true;
}
